import { client } from '@stores'
import { adminSpaceSearch } from './queries'
import { IAdminSearchSpace, IConnection } from '@api/types'

interface Payload {
  data: {
    viewer: {
      company: {
        search: {
          spaces: IConnection<IAdminSearchSpace>
        }
      }
    }
  }
}
export default async function adminSpace({
  query,
  apId,
  after,
  location,
  unseated,
}: {
  query: string
  apId: string
  after?: string | null
  location?: boolean
  unseated?: boolean
}): Promise<IConnection<IAdminSearchSpace>> {
  const variables = {
    query,
    unseated,
    assignmentPlanId: apId,
    location,
    fetchEmployeeBooking: false,
    after: after || undefined,
  }
  return await client.gql.query({ query: adminSpaceSearch, variables }).then(
    ({
      data: {
        viewer: {
          company: {
            search: { spaces },
          },
        },
      },
    }: Payload) => spaces
  )
}
